"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../..");
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var widevine_license_aquisition_request_1 = require("./widevine-license-aquisition-request");
exports.createWidevineKeySystemOptionsGenerator = function () {
    return new __1.KeySystemOptionsGenerator(client_lib_js_player_addons_common_player_1.DrmType.Widewine, 'com.widevine.alpha', new __1.HTTPLicenseAcquisitionStrategy(widevine_license_aquisition_request_1.generateWidevineLicenseRequest, widevine_license_aquisition_request_1.widevineResponseHandler, widevine_license_aquisition_request_1.widevineRequestFunction));
};
